import { z } from 'zod';

export const UuidSchema = z.string().uuid();
export type Uuid = z.infer<typeof UuidSchema>;

export const TimestampSchema = z.string().datetime();
export type Timestamp = z.infer<typeof TimestampSchema>;

export const E164PhoneSchema = z
  .string()
  .regex(/^\+?[1-9]\d{7,14}$/, 'Telefone deve estar no formato E.164 (ex: +5511987654321)');
export type E164Phone = z.infer<typeof E164PhoneSchema>;
